import { Box } from '@mui/material';
import { common, grey, green } from '@mui/material/colors';

type ProgressBarProps = {
  percentage: number;
};

export const ProgressBar = ({ percentage }: ProgressBarProps) => (
  <Box
    width={350}
    position='relative'
    height={30}
    bgcolor={common.white}
    border='1px solid'
    borderColor={grey[300]}
    borderRadius='25px'
    fontSize={1}
  >
    <Box
      bgcolor={green[600]}
      borderRadius='inherit'
      height='100%'
      width={`${percentage * 100}%`}
      sx={{ transition: 'width .2s ease-in' }}
    />
  </Box>
);
